export default __webpack_public_path__ + "static/media/pbm_favicon_xwm_icon.16ec5e94.ico";